import { render, staticRenderFns } from "./FormattedTime.vue?vue&type=template&id=5d770958&scoped=true&"
import script from "./FormattedTime.vue?vue&type=script&lang=js&"
export * from "./FormattedTime.vue?vue&type=script&lang=js&"
import style0 from "./FormattedTime.vue?vue&type=style&index=0&id=5d770958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d770958",
  null
  
)

export default component.exports